import WebApi from "@/views/loyalty/shared/modules/web_api"

export class JustpayMediafileEndpointService {
    constructor () {
        this.url = `${process.env.VUE_APP_JUSTPAY_URL}api/mediafile/`
        this.webApi = new WebApi()
    }

    async deletePictureFile (fileId) {
        const file = await this.webApi.delete(`${this.url}pictureFile/${fileId}`)
        if (file) {
            if (!file.status_code) {
                if (!file.error) {
                    return file
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${file.status_code}`)
            }
        }
        return null
    }

    async getPictureFile (fileId) {
        const file = await this.webApi.get(`${this.url}pictureFile/${fileId}`)
        if (file) {
            if (!file.status_code) {
                if (!file.error) {
                    return file
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${file.status_code}`)
            }
        }
        return null
    }

    async uploadPictureFile (file) {
        const response = await this.webApi.post(`${this.url}pictureFile`, file, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
        if (response) {
            if (!response.status_code) {
                if (!response.error) {
                    return response
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${response.status_code}`)
            }
        }
        return null
    }
}
